module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('DModal', {
    staticStyle: {
      "z-index": "12312312312313"
    },
    attrs: {
      "show-close": false,
      "isBgOverlay": true,
      "appendToBody": true,
      "placeInTop": true
    },
    on: {
      "close": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('div', {
    staticClass: "d-modal",
    attrs: {
      "slot": "insertComponent"
    },
    slot: "insertComponent"
  }, [_c('div', {
    staticClass: "d-modal__header"
  }, [_c('div', [_c('h2', [_vm._v("Beregn UV-tillæg for tidsbegrænset periode")]), _vm._v(" "), _c('p', {
    staticClass: "tuv__subtitle"
  }, [_vm._v(_vm._s(_vm.userName))])]), _vm._v(" "), _c('div', {
    staticClass: "font-large icon__bg-circle d-modal__header__close",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('span', {
    staticClass: "icon-cross2"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "d-modal__content"
  }, [_c('p', {
    staticClass: "tuv__intro"
  }, [_vm._v("\n        Ansættelsen har en afvigende periode. Beregn UV-tillægget ud fra skoledage og UV-tid, så det matcher\n        den faktiske periode. Tillægget lægges som kladde i listen og sendes ikke til lønsystemet.\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "tuv__facts"
  }, [_c('div', {
    staticClass: "tuv__fact"
  }, [_c('span', {
    staticClass: "tuv__fact-label"
  }, [_vm._v("Ansættelsesgrad")]), _vm._v(" "), _c('span', {
    staticClass: "tuv__fact-value"
  }, [_vm._v(_vm._s(_vm.ansaettelsesgradPercent != null ? _vm.formatPercent(_vm.ansaettelsesgradPercent) : '—'))])]), _vm._v(" "), _c('div', {
    staticClass: "tuv__fact"
  }, [_c('span', {
    staticClass: "tuv__fact-label"
  }, [_vm._v("Periode")]), _vm._v(" "), _c('span', {
    staticClass: "tuv__fact-value"
  }, [_vm._v(_vm._s(_vm.periodLabel))])]), _vm._v(" "), _c('div', {
    staticClass: "tuv__fact"
  }, [_c('span', {
    staticClass: "tuv__fact-label"
  }, [_vm._v("Bruttotid")]), _vm._v(" "), _c('span', {
    staticClass: "tuv__fact-value"
  }, [_vm._v(_vm._s(_vm.yearNormHours != null ? _vm.formatDecimal(_vm.yearNormHours) : '—'))])]), _vm._v(" "), _c('div', {
    staticClass: "tuv__fact"
  }, [_c('span', {
    staticClass: "tuv__fact-label"
  }, [_vm._v("Lønkode")]), _vm._v(" "), _c('span', {
    staticClass: "tuv__fact-value"
  }, [_vm._v(_vm._s(_vm.salaryCodeLabel))])])]), _vm._v(" "), _c('div', {
    staticClass: "do-form-row"
  }, [_c('div', {
    staticClass: "d-input-group"
  }, [_c('label', {
    staticClass: "d-label"
  }, [_vm._v("Skoledage i skoleåret")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.schoolDaysInYear),
      expression: "schoolDaysInYear"
    }],
    staticClass: "d-input",
    attrs: {
      "type": "number",
      "min": "0",
      "inputmode": "numeric",
      "placeholder": "fx 200"
    },
    domProps: {
      "value": (_vm.schoolDaysInYear)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.schoolDaysInYear = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "d-input-group"
  }, [_c('label', {
    staticClass: "d-label"
  }, [_vm._v("Skoledage i periode")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.schoolDaysInPeriod),
      expression: "schoolDaysInPeriod"
    }],
    staticClass: "d-input",
    attrs: {
      "type": "number",
      "min": "0",
      "inputmode": "numeric",
      "placeholder": "fx 46"
    },
    domProps: {
      "value": (_vm.schoolDaysInPeriod)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.schoolDaysInPeriod = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "d-input-group"
  }, [_c('label', {
    staticClass: "d-label"
  }, [_vm._v("UV-grænse")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.graense),
      expression: "graense"
    }],
    staticClass: "d-input",
    attrs: {
      "type": "text",
      "inputmode": "decimal",
      "placeholder": "750"
    },
    domProps: {
      "value": (_vm.graense)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.graense = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "d-input-group"
  }, [_c('label', {
    staticClass: "d-label"
  }, [_vm._v("Justeret timetal")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.adjustedHours),
      expression: "adjustedHours"
    }],
    staticClass: "d-input",
    attrs: {
      "type": "text",
      "inputmode": "decimal",
      "placeholder": "Total UV-tid for perioden"
    },
    domProps: {
      "value": (_vm.adjustedHours)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.adjustedHours = $event.target.value
      }
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "tuv__hint"
  }, [_vm._v("\n          Som standard tæller al tildelt UV-tid med i beregningen. Hvis kun de skemalagte timer i perioden skal\n          bruges, rettes timetallet her. Husk også at opdatere opgaveoversigten, da det er den der danner grundlag\n          for løntilsagnet.\n        ")])]), _vm._v(" "), (_vm.isCalcValid) ? _c('div', {
    staticClass: "tuv__result"
  }, [_c('div', {
    staticClass: "tuv__result-steps"
  }, [_c('div', {
    staticClass: "tuv__result-row"
  }, [_c('span', [_vm._v("UV-timer omregnet til fuld tid")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.formatDecimal(_vm.uvOmregnetFuldtid)))])]), _vm._v(" "), _c('div', {
    staticClass: "tuv__result-row"
  }, [_c('span', [_vm._v("Overskud over grænse (fuld tid)")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.formatDecimal(_vm.surplusFuldtid)))])])]), _vm._v(" "), _c('div', {
    staticClass: "tuv__result-total"
  }, [_c('span', [_vm._v("UV-tillæg der udbetales i perioden")]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.formatDecimal(_vm.resultUnits)) + " timer")])]), _vm._v(" "), (_vm.resultUnits > 0) ? _c('div', {
    staticClass: "tuv__result-row tuv__result-row--sub"
  }, [_c('span', [_vm._v("Fordeles på")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.formatDecimal(_vm.unitsPerInstallment)) + " enh./md · " + _vm._s(_vm.installments) + " " + _vm._s(_vm.installments === 1 ? 'måned' : 'måneder'))])]) : _vm._e(), _vm._v(" "), (_vm.resultUnits <= 0) ? _c('p', {
    staticClass: "tuv__result-note"
  }, [_vm._v("\n          UV-tiden er under grænsen i perioden – der dannes ikke noget tillæg.\n        ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (!_vm.salaryCodeId) ? _c('p', {
    staticClass: "tuv__result-note"
  }, [_vm._v("\n        Stillingskategorien mangler en \"Lønkode over UV-grænse\", så der kan ikke dannes et tillæg.\n      ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "d-modal__buttons"
  }, [_c('div', {
    staticClass: "d-modal__buttons__left"
  }), _vm._v(" "), _c('div', {
    staticClass: "d-modal__buttons__right"
  }, [_c('button', {
    staticClass: "do-bttn",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('vue2.common.cancel')))]), _vm._v(" "), _c('button', {
    staticClass: "do-bttn do-bttn--submit",
    class: {
      'do-bttn--submit--loading': _vm.isSaving
    },
    attrs: {
      "disabled": !_vm.isValid || _vm.isSaving
    },
    on: {
      "click": _vm.generate
    }
  }, [_vm._v("\n          Dan UV-tillæg i listen\n        ")])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1e98ca56!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Supplements/UvLimitTidsbegraensetModal.vue
// module id = 1792
// module chunks = 1